import { startCase } from 'lodash-es';
const ENTITY_REFS = new Set([
    'client',
    'agreement'
]);
const ID_WORDS = new Set([
    'id',
    'ids'
]);
const entityRefOf = (column)=>column.entity_ref != null && ENTITY_REFS.has(column.entity_ref) ? column.entity_ref : undefined;
const stripTrailingIdWord = (titleCased)=>{
    var _words_;
    const words = titleCased.split(' ').filter((word)=>word.length > 0);
    const last = (_words_ = words[words.length - 1]) === null || _words_ === void 0 ? void 0 : _words_.toLowerCase();
    return last != null && ID_WORDS.has(last) ? words.slice(0, -1).join(' ') : words.join(' ');
};
export const humanizeKey = (raw, opts)=>{
    const titleCased = startCase(raw);
    if ((opts === null || opts === void 0 ? void 0 : opts.stripIdToken) !== true) return titleCased;
    return stripTrailingIdWord(titleCased) || titleCased;
};
export const humanizeColumnHeader = (column, fallback)=>{
    const entityRef = entityRefOf(column);
    if (entityRef == null) return startCase(column.name);
    const stripped = stripTrailingIdWord(startCase(column.name));
    return stripped === '' ? fallback[entityRef] : stripped;
};
